module.exports = __webpack_public_path__ + "media/headerBgm.6a2ad37a.mp4";